import { render } from "./MonkeyLoader.vue?vue&type=template&id=4c838a4f"
import script from "./MonkeyLoader.vue?vue&type=script&lang=js"
export * from "./MonkeyLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__